module.exports = __webpack_public_path__ + "img/cat.038d3eed.png";